var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.auth.show,
          expression: "auth.show"
        }
      ],
      staticClass: "lite_popup add_drive"
    },
    [
      _c("div", { staticClass: "lite_popup_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.auth.did
                  ? _vm.$t("language.leftBanner.edit")
                  : _vm.$t("language.common.addCloud")
              )
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                _vm.auth.show = false
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content" },
          [
            _c(
              "el-form",
              { attrs: { model: _vm.auth, "label-width": "110px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("language.common.type") } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.auth.type,
                        callback: function($$v) {
                          _vm.$set(_vm.auth, "type", $$v)
                        },
                        expression: "auth.type"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("language.popup.addCloudPopup.cloudName")
                    }
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.auth.name,
                        callback: function($$v) {
                          _vm.$set(_vm.auth, "name", $$v)
                        },
                        expression: "auth.name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.auth.type == "FTP"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.protocol"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.auth.ftp.protocol,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth.ftp, "protocol", $$v)
                                  },
                                  expression: "auth.ftp.protocol"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "ftp-plain",
                                    value: "ftp-plain"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "ftps-explicit",
                                    value: "ftps-explicit"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "ftps-implicit",
                                    value: "ftps-implicit"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.host,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "host", $$v)
                                },
                                expression: "auth.ftp.host"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.port")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "port", $$v)
                                },
                                expression: "auth.ftp.port"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "username", $$v)
                                },
                                expression: "auth.ftp.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "password", $$v)
                                },
                                expression: "auth.ftp.password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passive"
                              )
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "switch-box" },
                              [
                                _c("el-switch", {
                                  attrs: { "active-color": "#5166BD" },
                                  model: {
                                    value: _vm.auth.ftp.passive,
                                    callback: function($$v) {
                                      _vm.$set(_vm.auth.ftp, "passive", $$v)
                                    },
                                    expression: "auth.ftp.passive"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.encoding"
                              )
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: _vm.auth.ftp.encoding,
                                  callback: function($$v) {
                                    _vm.$set(_vm.auth.ftp, "encoding", $$v)
                                  },
                                  expression: "auth.ftp.encoding"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: {
                                    label: "ISO-8859-1",
                                    value: "ISO-8859-1"
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "UTF-8", value: "UTF-8" }
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "GBK", value: "GBK" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.path")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.ftp.path,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.ftp, "path", $$v)
                                },
                                expression: "auth.ftp.path"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "SFTP"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.host,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "host", $$v)
                                },
                                expression: "auth.sftp.host"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.port")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.port,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "port", $$v)
                                },
                                expression: "auth.sftp.port"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "username", $$v)
                                },
                                expression: "auth.sftp.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "password", $$v)
                                },
                                expression: "auth.sftp.password"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.privateKey"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.auth.sftp.privateKey,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "privateKey", $$v)
                                },
                                expression: "auth.sftp.privateKey"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passphrase"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.passphrase,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "passphrase", $$v)
                                },
                                expression: "auth.sftp.passphrase"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("language.popup.addCloudPopup.path")
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.sftp.path,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.sftp, "path", $$v)
                                },
                                expression: "auth.sftp.path"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "WebDAV"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.server"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.webdav.url,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "url", $$v)
                                },
                                expression: "auth.webdav.url"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.userName"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.webdav.username,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "username", $$v)
                                },
                                expression: "auth.webdav.username"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.webdav.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.webdav, "password", $$v)
                                },
                                expression: "auth.webdav.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.auth.type == "MediaFire"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("language.popup.email") } },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.mediafire.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mediafire, "email", $$v)
                                },
                                expression: "auth.mediafire.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "language.popup.addCloudPopup.passWord"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.auth.mediafire.password,
                                callback: function($$v) {
                                  _vm.$set(_vm.auth.mediafire, "password", $$v)
                                },
                                expression: "auth.mediafire.password"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.submit()
                }
              }
            },
            [
              _vm.auth.loading
                ? _c("i", {
                    staticClass: "el-icon-loading",
                    staticStyle: { color: "#fff" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.auth.did
                      ? _vm.$t("language.leftBanner.edit")
                      : _vm.$t("language.common.addCloud")
                  )
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c478465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c478465","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_add_drive.vue
// module id = null
// module chunks = 